const kidsAdventuresFrontRulesKeys = {
    'KIDS-ADVENTURES-LIST-ITEM-REMOVE': 'kids-adventures-list-item-remove',
    'KIDS-ADVENTURES-ITEM-ARRIVALS-LIST-ROW-REMOVE': 'kids-adventures-item-arrivals-list-row-remove',
}

const kidsAdventuresFrontRulesArray = [
    { key: kidsAdventuresFrontRulesKeys['KIDS-ADVENTURES-LIST-ITEM-REMOVE'], label: 'frontRoles.sidebar.kids.adventures.removeItem' },
    { key: kidsAdventuresFrontRulesKeys['KIDS-ADVENTURES-ITEM-ARRIVALS-LIST-ROW-REMOVE'], label: 'frontRoles.sidebar.kids.adventures.removeRow' },
]

module.exports = {
    kidsAdventuresFrontRulesKeys,
    kidsAdventuresFrontRulesArray
}